import request from './request';
import {CUSTOM_FORM_API} from '@/urls';
import {API_METHODS, ERROR_CODE, TIME} from '@/const';

export default {
  get_custom_form(alias) {
    return request({
      url: `${CUSTOM_FORM_API}/${alias}`,
      method: API_METHODS.GET,
      config: {
        retryCount: 1,
        globalError: false,
        retryDelay: TIME.SECOND,
        crashCodes: ['5\\d\\d'],
        allowedCodes: [ERROR_CODE.NOT_FOUND],
        skipTrackingCodes: [ERROR_CODE.UNAUTHENTICATED, ERROR_CODE.NOT_FOUND],
      },
    }).then((res) => {
      return res;
    }).catch(() => {
    });
  },
  update_custom_form(alias, props = {}) {
    return request({
      url: `${CUSTOM_FORM_API}/${alias}`,
      params: props,
      method: API_METHODS.POST,
    });
  },
};
